module.exports = __webpack_public_path__ + "static/media/iceland_007.bb304d2c.jpg";